/* About (new), the About page at /pages/about since the CEO approved it on 2026-10-19 (templates/page.about.json), after
   the moments kit (assets/cg-moments.js, window.CGMO). Three parts: (1) the opening, where the genie light runs along
   the table's edge, then settles under the glow words; (2) the timeline, drawn once in view; (3) the living team, the
   page's one pinned moment: four beats on native scroll. Everything plays once, moves only pictures, and is finished
   and still when motion is off (CGMO.live false). The Pause animations button (cg:motion) switches it in place:
   paused, everything shows finished and the team is unpinned; played again, what was shown stays finished, the
   timeline still draws if it is not reached yet, and the team pins again where it fits. The closing lamp is the
   kit's. Words live in the sections. */
(function () {
  'use strict';
  var MO = window.CGMO;
  var PAGE = document.getElementById('pg-about');
  if (!MO || !PAGE) return;
  function all(root, sel) { return [].slice.call(root.querySelectorAll(sel)); }
  function on(els) { els.forEach(function (el) { el.classList.add('on'); }); }
  function motion(fn) { document.addEventListener('cg:motion', fn); }

  // ---- (1) the opening: once, after the page has loaded and the main thread is free
  function opening(sec) {
    var glow = all(sec, '.mo-gw'), edge = sec.querySelector('.ab-edge');
    // paused or played again: the light is simply there
    motion(function () { if (edge) edge.classList.add('on'); on(glow); });
    if (!MO.live) { on(glow); return; }
    function play() {
      if (!MO.live) return;
      if (edge) edge.classList.add('on');
      setTimeout(function () { on(glow); }, edge ? 1200 : 200);
    }
    var go = function () { (window.requestIdleCallback || function (f) { return setTimeout(f, 120); })(play, { timeout: 900 }); };
    if (document.readyState === 'complete') go(); else addEventListener('load', go, { once: true });
  }

  // ---- (2) the timeline: the light draws the line and the marks light up, once
  function years(sec) {
    var done = false;
    function draw() { done = true; sec.classList.add('on'); }
    function arm() { MO.when(sec, 0.7, draw); }
    // paused, the line is finished without the class (the CSS); played again before the visitor reached it, it still
    // draws when it arrives; otherwise it stays finished
    motion(function () {
      if (!MO.live) return;
      if (!done && sec.getBoundingClientRect().top >= window.innerHeight) arm();
      else draw();
    });
    if (MO.live) arm();
  }

  // ---- (3) the living team: the people, the light down to Jenny, her Agent Apps and the waves, then all settles
  function team(sec) {
    var pin = sec.querySelector('.ab-pin'), beats = all(sec, '.ab-beat');
    var n = beats.length, cur = -1, wave = -1;
    if (!pin || !n) return;
    function set(p) {
      var i = Math.min(n - 1, Math.floor(p * n * 0.999));
      if (i !== cur) {
        cur = i;
        sec.setAttribute('data-beat', String(i));
        beats.forEach(function (b, k) { b.classList.toggle('on', k === i); });
      }
      // the waves of working agents arrive through the third beat, and stay
      var w = i < 2 ? 0 : i > 2 ? 3 : 1 + Math.min(2, Math.floor((p * n - 2) * 3));
      if (w !== wave) {
        wave = w;
        for (var k = 1; k <= 3; k++) sec.classList.toggle('w' + k, k <= w);
      }
    }
    // pin only while motion is on and where the moment fits, decided again whenever the window changes size (as on
    // Agent Apps): a phone turned sideways gets the still version, and turned back the pin returns
    var pinned = false, sc = null, raf = 0;
    var probe = document.createElement('div');
    probe.setAttribute('aria-hidden', 'true');
    probe.style.cssText = 'position:fixed;left:0;top:0;width:0;height:100vh;height:100svh;visibility:hidden;pointer-events:none';
    document.body.appendChild(probe);
    var fits = function (need) { return (probe.offsetHeight || window.innerHeight) - MO.head() >= need; };
    function pinOn() {
      pinned = true;
      sec.classList.add('ab-on');
      cur = -1; wave = -1; set(0);
      if (!sc) sc = MO.scene(sec, pin, function (p) { if (pinned) set(p); });
      else MO.remeasure();
    }
    function pinOff() {
      pinned = false;
      sec.classList.remove('ab-on', 'w1', 'w2', 'w3');
      sec.removeAttribute('data-beat');
      beats.forEach(function (b) { b.classList.remove('on'); });
      MO.remeasure();
    }
    function decide() {
      raf = 0;
      if (MO.live && !pinned && fits(560)) pinOn();
      else if (pinned && !(MO.live && fits(520))) pinOff();
    }
    function soon() { if (!raf) raf = requestAnimationFrame(decide); }
    if (MO.live && fits(520)) pinOn();
    addEventListener('resize', soon);
    addEventListener('orientationchange', soon);
    motion(function () {
      if (MO.live) { if (!pinned && fits(520)) pinOn(); return; }
      if (pinned) pinOff();
    });
  }

  all(PAGE, '.ab-open').forEach(opening);
  all(PAGE, '.ab-years').forEach(years);
  all(PAGE, '.ab-team').forEach(team);
})();
